import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './components/layout/Sidebar';
import { Topbar } from './components/layout/Topbar';

/**
 * App shell. The hub app rail (index.html script) auto-offsets <body>:
 * 64px left margin on desktop, 56px top below 1024px — do not double-offset.
 *
 * The shell owns TWO things every page used to decide for itself:
 *
 * 1. **Content width.** Twelve pages picked their own cap and the column
 *    measured 1024 / 1152 / 1280 / 1400 / 1632 depending on where you were —
 *    /clients to /agreements moved the left edge 64px, /agreements to /dashboard
 *    moved it 176px. One cap here; a page that genuinely wants to be narrower
 *    (a printable invoice) or has a fixed grid (the timesheet) still says so,
 *    but it has to mean it.
 * 2. **The entrance.** Six pages faded in via `page-enter`, four via
 *    `animate-fade-in` (the same keyframes under a second name), and five —
 *    /invoices, /budgets, /time, /team and the since-retired /sales-pipeline —
 *    did not animate at all, so half the app arrived and half of it appeared.
 *    Keyed on pathname so it fires once per navigation.
 */
export default function App() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-screen">
      <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onMenuClick={() => setMobileNavOpen(true)} />
        <main className="flex-1 p-4 sm:p-6">
          <div key={pathname} className="page-enter mx-auto w-full max-w-[1600px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
